module.exports = __webpack_public_path__ + "img/hzLogo8.a66f6f85.png";